import { render } from "./CultureCurious.vue?vue&type=template&id=2fcf8991"
import script from "./CultureCurious.vue?vue&type=script&lang=js"
export * from "./CultureCurious.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__